import React from "react";
import { Flex } from "antd";
import SbCheckbox from "uiCore/SbCheckbox/SbCheckbox";
import sb_pin from "Assets/Icons/push-pin.svg";
import { PinBadgeWrapperStyled } from "./PrioritySkillCell.styles";

const PrioritySkillCell = ({ checked, onChange }) => (
  // Plain <Flex> replaces the removed PrioritySkillCellContainerStyled
  <Flex align="center" justify="center" gap={16}>
    <SbCheckbox checked={checked} onChange={onChange} />
    <PinBadgeWrapperStyled $visible={checked}>
      <img src={sb_pin} width={22} alt="priority" />
    </PinBadgeWrapperStyled>
  </Flex>
);

export default PrioritySkillCell;
